import { AgentFileUploadSchema, LanguageModel } from 'models'

/**
 * Every model an agent can be set to, in the order `LanguageModel` declares
 * them. Derived on purpose: the hand-written copy of this list drifted from the
 * enum twice, leaving models in the dropdown that the gateway had already
 * retired (and, the other way round, ids nobody could select).
 */
export const MODELS = Object.values(LanguageModel)

export const DEFAULT_TEMPERATURE = 0.6
export const DEFAULT_PROMPT = ''
export const DEFAULT_LIMIT = 5
export const FILE_UPLOAD_DEFAULTS = AgentFileUploadSchema.parse({})
